import React from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

// Shared "QBO Product/Service" input. MUI v4's freeSolo Autocomplete only commits through onChange
// on select / Enter / clear, so a typed code was lost on blur while the input kept displaying it.
// Committing on blur fixes that; `autoSelect` would commit the highlighted option instead.
const QboTagField = ({ value, options, onCommit, className }) => {
    const current = value || '';

    const commit = (next) => {
        const trimmed = (next || '').trim();
        if (trimmed !== current) {
            onCommit(trimmed);
        }
    };

    return (
        <Autocomplete
            freeSolo
            size="small"
            options={options || []}
            value={current}
            onChange={(_, newValue) => commit(newValue)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    className={className}
                    label="QBO Product/Service"
                    inputProps={{
                        ...params.inputProps,
                        onBlur: (event) => {
                            // freeSolo's handleBlur leaves the input text alone, so target.value
                            // is still whatever was typed.
                            params.inputProps.onBlur?.(event);
                            commit(event.target.value);
                        },
                    }}
                />
            )}
        />
    );
};

export default QboTagField;
